<template>
  <div>
    <AGB :agreed.sync="consentAGBProp" process="belatedPorting">
      <template #headline><slot name="headlineAGB"></slot></template>
      <template #txtAGB><slot name="txtAGB"></slot></template>
      <template #txtAGBwithLink><slot name="txtAGBwithLink"></slot></template>
    </AGB>
    <NumberPortingConsent
      ref="numberPortingConsent"
      :selectedNumberPortingConsentProp.sync="selectedNumberPortingConsentProp"
    >
      <template #txtNumberPorting><slot name="txtNumberPorting"></slot></template>
      <template #txtConfirmationRequired><slot name="txtConfirmationRequired">Dies ist ein Pflichtfeld.</slot></template>
    </NumberPortingConsent>
  </div>
</template>
<script>
import AGB from '@/components/checkout/summary/Consent/AGB.vue'
import NumberPortingConsent from '@/components/checkout/belatedPorting/summary/NumberPortingConsent.vue'
import syncProperty from '@/mixins/syncProperty'

export default {
  name: 'ConsentWrapper',
  mixins: [
    syncProperty('selectedNumberPortingConsent', 'selectedNumberPortingConsentProp'),
    syncProperty('consentAGB', 'consentAGBProp')
  ],
  components: {
    AGB,
    NumberPortingConsent
  },
  computed: {
    isIosDevice () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }
  },
  methods: {
    validate: function () {
      this.$refs.numberPortingConsent.validateForm()
    }
  }
}
</script>
